import React from 'react';
import { styled } from '@mui/system';
import {  Button, Menu, MenuItem, MenuList } from '@mui/material';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import NightlightOutlinedIcon from '@mui/icons-material/NightlightOutlined';
import BrightnessAutoOutlinedIcon from '@mui/icons-material/BrightnessAutoOutlined';
import useStyles, { Colortheme } from '../../pages/comman';
import { useDispatch } from 'react-redux';
import { changeModeAction } from '../../slices/layouts/reducer';

const StyledDropdownButton = styled(Button)`
  && {
    background-color: transparent;
    border: none;
    border-radius: 50px
    // padding: 0;
    cursor: pointer;
    height: 42px;
    width: 42px;
    display: flex;
    justify-content: center;
  }
`;

const StyledMenuItem = styled(MenuItem)`
  && {
    display: flex;
    align-items: center;
  }
`;

const StyledIcon = styled('span')`
  && {
    margin-right: 8px;
    height: 42px;
    width: 42px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const ModeDropdown = () => {

    const { inherit } = Colortheme();
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const { cardbg, cardBorder } = Colortheme();
    const classes = useStyles();
    const dispatch: any = useDispatch();

    return (
        <React.Fragment>
            <div className="header-item">
                <StyledDropdownButton
                    aria-expanded="false"
                    aria-controls="light-dark-mode"
                    onClick={handleClick}
                    sx={{ minWidth: '50px' }}
                >
                    <StyledIcon>
                        <LightModeOutlinedIcon sx={{ fontSize: 20, color: inherit }} />
                    </StyledIcon>
                </StyledDropdownButton>
                <Menu
                    id="light-dark-mode"
                    anchorEl={anchorEl}
                    className={classes.headerDropdown}
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                    sx={{marginTop:'12px'}}

                >
                    <MenuList style={{ backgroundColor: cardbg, border: '1px solid ', borderColor: cardBorder, padding: '8px 4px' }} >
                        <StyledMenuItem data-mode="light" sx={{ fontSize: '14px', color: inherit }} onClick={() => {dispatch(changeModeAction('light')); handleClose();}}>
                            <LightModeOutlinedIcon sx={{ fontSize: '20px', marginRight: '10px' }} />
                            Default (light mode)
                        </StyledMenuItem>
                        <StyledMenuItem data-mode="dark" sx={{ fontSize: '14px', color: inherit }} onClick={() => {dispatch(changeModeAction('dark')); handleClose();}}>

                            <NightlightOutlinedIcon sx={{ fontSize: '20px', marginRight: '10px' }} />
                            Dark
                        </StyledMenuItem>
                        <StyledMenuItem data-mode="auto" sx={{ fontSize: '14px', color: inherit }} onClick={() => {dispatch(changeModeAction('light')); handleClose();}}>
                            <BrightnessAutoOutlinedIcon sx={{ fontSize: '20px', marginRight: '10px' }} />
                            Auto (system default)
                        </StyledMenuItem>
                    </MenuList>
                </Menu>
            </div>
        </React.Fragment >
    );
};

export default ModeDropdown;